import { useContext } from "react";
import { IUserInfo } from "utilFunctions/CommonInterfaces/userInterface";
import { UserInfoContext } from "Context/CommonContext";
interface useViewAccessIF {
  UserRoleAccess: string[];
}
const useViewAccess = ({ UserRoleAccess }: useViewAccessIF) => {
  const userInfo = useContext<IUserInfo>(UserInfoContext);
  const { fexRole } = userInfo;
  const isViewOnly: boolean = UserRoleAccess.includes(fexRole as string);
  return {
    isViewOnly,
  };
};

export default useViewAccess;
